import { parseAsArrayOf } from 'nuqs';

import { useQuotationFilters } from '~/api/quotations';
import { ColumnIds } from '~/constants/table';
import { SearchParamKeys } from '~/constants/url';
import { includes } from '~/utils/arrays';
import { createTableSearchParams, parseAsIntegerWithValidation, parseAsStringWithValidation } from '~/utils/nuqs';

export const {
  useColumnFilters: useQuotationsTableColumnFilters,
  useGlobalFilter: useQuotationsTableGlobalFilter,
  usePaginationState: useQuotationsTablePaginationState,
  useSorting: useQuotationsTableSorting,
} = createTableSearchParams({
  columnFilters: {
    [SearchParamKeys.columnFilterClient]: ColumnIds.quotationsClient,
    [SearchParamKeys.columnFilterBrand]: ColumnIds.quotationsBrand,
    [SearchParamKeys.columnFilterYears]: ColumnIds.quotationsDocYear,
    [SearchParamKeys.columnFilterQuarters]: ColumnIds.quotationsDocQuarter,
    [SearchParamKeys.columnFilterStatuses]: ColumnIds.quotationsStatus,
  },
  defaultSorting: { id: ColumnIds.quotationsDocDate, desc: true },
  sortableColumnIds: [
    ColumnIds.quotationsTitle,
    ColumnIds.quotationsClient,
    ColumnIds.quotationsDocDate,
    ColumnIds.quotationsStatus,
    ColumnIds.quotationsTotal,
  ],
  sortingIdPrefix: 'quotations_',
  useColumnFilterParsers: () => {
    const { data: filters } = useQuotationFilters();

    return {
      [SearchParamKeys.columnFilterClient]: parseAsIntegerWithValidation((value) => includes(filters.clientIds, value)),
      [SearchParamKeys.columnFilterBrand]: parseAsIntegerWithValidation((value) => includes(filters.brandIds, value)),
      [SearchParamKeys.columnFilterYears]: parseAsArrayOf(
        parseAsIntegerWithValidation((value) => includes(filters.years, value)),
      ).withDefault([]),
      [SearchParamKeys.columnFilterQuarters]: parseAsArrayOf(
        parseAsStringWithValidation((value) => includes(filters.quarters, value)),
      ).withDefault([]),
      [SearchParamKeys.columnFilterStatuses]: parseAsArrayOf(
        parseAsStringWithValidation((value) => includes(filters.statuses, value)),
      ).withDefault([]),
    };
  },
});
